import * as Yup from 'yup'

/**
 * The rule for a name the user is actually typing.
 *
 * The cap mirrors the backend (`BaseUser.first_name/last_name`,
 * `max_length=100`) rather than inventing a shorter one. It used to be 15,
 * which is under a normal Persian last name once a prefix or a cohort suffix
 * is on it — «تهرانی مشکات پردیسان» is 20 — so the form rejected values the
 * database was perfectly happy to store.
 */
const nameRule = (label: string) =>
    Yup.string()
        .required(`${label} الزامی می‌باشد`)
        .min(2, `${label} نمی‌تواند کمتر از ۲ کاراکتر باشد`)
        .max(100, `${label} نمی‌تواند بیشتر از ۱۰۰ کاراکتر باشد`)

/**
 * Validate only what the user can reach.
 *
 * A name that is already on the account is rendered as read-only text, not as
 * an input. Validating it anyway is how the «ورود» button went dead: Formik
 * failed on a field with no input and no error slot, refused to submit, and
 * showed nothing at all — so the last screen of login became a button that
 * does nothing, forever, for every member whose stored name broke the old
 * 15-character cap.
 *
 * Anything that arrived from the server is valid by definition; the only
 * values worth checking are the ones being typed right now.
 */
export const makeSchema = (editable: { first: boolean; last: boolean }) =>
    Yup.object().shape({
        first_name: editable.first ? nameRule('نام') : Yup.string(),
        last_name: editable.last ? nameRule('نام خانوادگی') : Yup.string(),
    })

export const initialValues = (profileData: IAuthProfileData | undefined) => {
    return {
        first_name: profileData?.first_name ? profileData?.first_name : '',
        last_name: profileData?.last_name ? profileData?.last_name : '',
        email: profileData?.email ? profileData?.email : '',
    }
}
